/**
 * Класс ExtentResult предназначен для возврата данных об экстенте в базовом варианте (массив) и в виде объекта
 * @param {array} (number,number,number,number) - Хmin, Ymin, Xmax, Ymax
 * @return {array} extent - Исходный массив координат
 * @return {object} properties - Объект со свойствами xmin, ymin, xmax, ymax
 */
class ExtentResult {
  constructor(params) {
    this.extent = params;
    this.properties = {
      xmin: params[0],
      ymin: params[1],
      xmax: params[2],
      ymax: params[3]
    }
  }
}

module.exports = ExtentResult;